/** 总览展示用纯函数（可单测） */

export type OverviewWindow = "today" | "7d" | "14d";

export function windowLabel(window: OverviewWindow): string {
  switch (window) {
    case "7d":
      return "近 7 日复盘";
    case "14d":
      return "近 14 日复盘";
    default:
      return "今日作战";
  }
}

export function outboundStatusLabel(status: string): string {
  switch (status) {
    case "pending_confirm":
      return "待企微确认";
    case "sent":
      return "已发送";
    case "failed":
      return "失败";
    case "voided":
      return "已作废";
    case "cancelled":
      return "已取消";
    default:
      return status;
  }
}

/** 跳转执行账本的 query */
export function executionQuery(status: string): string {
  return `?status=${encodeURIComponent(status)}`;
}

export function chartEmpty(series: {
  sent_people: number[];
  new_contacts: number[];
  churned_contacts: number[];
}): boolean {
  const sum = (arr: number[]) => arr.reduce((a, b) => a + b, 0);
  return (
    sum(series.sent_people) === 0 &&
    sum(series.new_contacts) === 0 &&
    sum(series.churned_contacts) === 0
  );
}

/** 跳转客户列表的 query（Customers 页可逐步消费） */
export function customersQuery(opts: {
  journeyDefinitionId?: number | null;
  status?: string | null;
}): string {
  const params = new URLSearchParams();
  if (opts.journeyDefinitionId != null) {
    params.set("journey", String(opts.journeyDefinitionId));
  }
  if (opts.status) params.set("outbound_status", opts.status);
  const q = params.toString();
  return q ? `?${q}` : "";
}

export function wecomConfirmHint(): string {
  return "请打开企业微信 → 客户联系 → 群发确认，由员工点发送。站内不会代发。";
}
